/* eslint-disable max-len */
// Dependencies
import React from 'react'
import {connect} from 'react-redux'

// Actions
import {storePayload} from '../actions/storePayload.js'

// Components
import SectionSelect from './SectionSelect.js'
import FormControl from './FormControl.js'
import SectionReview from './SectionReview.js'
// import Output from './Output.js'
// import Section from './Section.js'
// import {Icon, Button} from '@lazarusai/forms-ui-components'

// Styles
import '@lazarusai/forms-ui-components-test/dist/index.css'
import '../styles/Workflow.css'
import TypeForm from './TypeForm.js'
import ChatSection from './ChatSection.js'
import ResponseReview from './ResponseReview.js'
// import AlfredInput from './AlfredInput.js'

function Workflow(props) {
  const render = {
    'response-review': <ResponseReview />,
    'section-review': <SectionReview />,
    'typeform':
      <>
        <TypeForm />
        <FormControl theme={props.theme} />
      </>,
  }
  return (
    <>
      {/* To do: Clean this up like App.js */}
      <ChatSection />
      <SectionSelect />
      {render[props.typeFormStep]}
    </>
  )
}

const mapStateToProps = (state) => ({
  theme: state.userReducer.theme,
  selectedSubSectionName: state.userReducer.selectedSubSectionName,
  prompt1Response: state.userReducer.prompt1Response,
  isChatShowing: state.userReducer.isChatShowing,
  chatHistory: state.userReducer.chatHistory,
  question: state.userReducer.question,
  isResponseReview: state.userReducer.isResponseReview,
  isSectionReview: state.userReducer.isSectionReview,
  typeFormStep: state.userReducer.typeFormStep,
})

export default connect(
    mapStateToProps,
    {storePayload},
)(Workflow)
